import {
  FETCH_CUSTOMER_REQUEST,
  FETCH_CUSTOMER_SUCCESS,
  FETCH_CUSTOMER_FAILURE,
  CLEAR_CUSTOMER,
} from '../actions/customer';

const defaultState = {
  loading: false,
  loaded: false,
  item: null,
};

export default function orders(state = defaultState, action) {
  switch (action.type) {
    case CLEAR_CUSTOMER:
      return {
        ...state,
        defaultState
      };
    case FETCH_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        item: action.payload.item,
        lastUpdated: action.payload.receivedAt,
      };
    case FETCH_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
